import type { IconSvgObject } from './types';

const DoorClosedIcon: IconSvgObject = [
  ["path", { d: "M3 21.002H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 21.002V5.00195C5 3.89738 5.89543 3.00195 7 3.00195H17C18.1046 3.00195 19 3.89738 19 5.00195V21.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 12.002H9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DoorClosedIcon;
